interface ServiceCardProps {
  icon: string;
  title: string;
  description: string;
  availability: string;
}

export default function ServiceCard({ icon, title, description, availability }: ServiceCardProps) {
  return (
    <div className="bg-white rounded-lg p-6 shadow-subtle hover:shadow-elevated transition-all duration-300 border border-border">
      <div className="flex items-start space-x-4">
        <div className="w-14 h-14 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
          <span className="text-3xl">{icon}</span>
        </div>
        <div className="flex-1">
          <h4 className="font-display text-lg font-semibold text-text-primary mb-2">{title}</h4>
          <p className="text-text-secondary text-sm mb-3 leading-relaxed">{description}</p>
          <div className="flex items-center space-x-2">
            <svg className="w-4 h-4 text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span className="text-xs text-muted-foreground font-medium">{availability}</span>
          </div>
        </div>
      </div>
    </div>
  );
}